var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    attrs: {
      "id": "orderItemsUpload",
      "action": _vm.$root.front_end_configs.router_url + 'fileupload',
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "ddbox"
  }, [_c('input', {
    ref: "file",
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": "fileToLoad",
      "disabled": _vm.isSaving
    },
    on: {
      "change": _vm.selectFile
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('Drag your file here or click to browse')))]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v(_vm._s(_vm.file.name))]) : _vm._e()]), _vm._v(" "), (_vm.file) ? _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "margin-top": "15px",
      "margin-right": "15px",
      "float": "right"
    },
    attrs: {
      "disabled": _vm.isSyncing
    }
  }, [_c('input', {
    staticStyle: {
      "border-color": "transparent",
      "background-color": "inherit"
    },
    attrs: {
      "type": "submit"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.uploadedFiles.length) + " " + _vm._s(_vm.$Jed.translate('file uploaded successfully', _vm.uploadedFiles.length)) + " ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
  })), _vm._v(" "), (_vm.uploadWarning.length > 0) ? _c('pre', {
    staticStyle: {
      "margin": "10px 0px",
      "white-space": "normal",
      "overflow-y": "scroll",
      "height": "90px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('warning')) + ": " + _vm._s(_vm.uploadWarning))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px 0px 10px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('Upload again')))])])]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('warning')))]), _vm._v(" "), _c('pre', {
    staticStyle: {
      "margin": "10px 0px",
      "white-space": "normal",
      "overflow-y": "scroll",
      "height": "90px"
    }
  }, [_vm._v(_vm._s(_vm.uploadError))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px 0px 10px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('Try again')))])])]) : _vm._e()]), _vm._v(" "), (_vm.loadingfile) ? _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "right": "25px",
      "left": "0px"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "20px"
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf7e92a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/UploadFile.vue
// module id = 1714
// module chunks = 1